import { ImgHTMLAttributes, useLayoutEffect, useRef, useState } from "react"

import { useMediaQuery } from "@chakra-ui/react"

import {
  FALLBACK_LOGO_IMAGE,
  IMAGE_POSTFIX_MOBILECARD,
  IMAGE_POSTFIX_WEBCARD,
  IMAGE_POSTFIX_WEBFULL,
} from "utils/global-constants"

const ImageWithFallback = ({
  src = "",
  postfix,
  fallbackSrc = FALLBACK_LOGO_IMAGE,
  minWidth = "",
  maxHeight = "",
  minHeight = "",
  borderRadius = "6px",
  ...rest
}: {
  postfix?:
    | typeof IMAGE_POSTFIX_WEBCARD
    | typeof IMAGE_POSTFIX_MOBILECARD
    | typeof IMAGE_POSTFIX_WEBFULL
    | null
  fallbackSrc?: string
  minWidth?: string
  borderRadius?: string
  maxHeight?: string
  minHeight?: string
} & ImgHTMLAttributes<HTMLImageElement>) => {
  const imgRef = useRef<HTMLImageElement | null>(null)
  const [isMobile] = useMediaQuery("(max-width: 768px)")
  const handleError = () => {
    if (imgRef.current) {
      // Update src to fallbackSrc
      imgRef.current.src = imgRef.current.src.includes(
        `${src}_${postfix || ""}`,
      )
        ? src
        : fallbackSrc
    }
  }

  const [isLoaded, setIsLoaded] = useState(isMobile)
  useLayoutEffect(() => {
    setIsLoaded(true)
  }, [])

  if (!isLoaded) return null

  return (
    <img
      ref={imgRef}
      src={src && postfix ? `${src}${postfix}` : src}
      alt=''
      onError={handleError}
      style={{
        minWidth,
        borderRadius,
        maxHeight,
        minHeight,
        objectFit: "cover",
      }}
      {...rest}
    />
  )
}

export default ImageWithFallback
